import { render, staticRenderFns } from "./EventBet.vue?vue&type=template&id=80473b18"
import script from "./EventBet.vue?vue&type=script&lang=js"
export * from "./EventBet.vue?vue&type=script&lang=js"
import style0 from "./EventBet.vue?vue&type=style&index=0&id=80473b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports